(function () {
  var WORKER_URL = "https://revup-pet-search.revup.workers.dev/";
  var form = document.getElementById('rev-search-form');
  var statusEl = document.getElementById('rev-results-status');
  var gridEl = document.getElementById('rev-results-grid');
  var submitBtn = form.querySelector('.find-rev-submit');
  var tabs = document.querySelectorAll('.find-rev-tab');
  var orgWrap = document.getElementById('rev-org-select-wrap');
  var orgSelect = document.getElementById('rev-org-select');
  var breedInput = document.getElementById('rev-breed');
  var loadMoreWrap = document.getElementById('rev-load-more-wrap');
  var loadMoreBtn = document.getElementById('rev-load-more');

  var currentMode = 'pets';
  var currentOrgID = null;
  var currentOrgUrl = null;
  var orgUrlsById = {};
  var breedDebounceTimer = null;

  // Pagination state
  var currentPage = 1;
  var currentPages = 1;
  var totalShown = 0;
  var lastPetParams = null; // { zip, distance, state, breed } — used by Load More in pets mode

  function resetPagination() {
    currentPage = 1;
    currentPages = 1;
    totalShown = 0;
    loadMoreWrap.style.display = 'none';
    loadMoreBtn.disabled = false;
    loadMoreBtn.textContent = 'Load More';
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      currentMode = tab.getAttribute('data-mode');
      currentOrgID = null;
      currentOrgUrl = null;
      orgWrap.style.display = 'none';
      orgSelect.innerHTML = '';
      gridEl.innerHTML = '';
      resetPagination();
      statusEl.textContent = currentMode === 'rescues'
        ? 'Enter your zip code and search to find rescues near you.'
        : '';
    });
  });

  function dogCardHtml(dog, fallbackUrl, fallbackOrgName) {
    var photoHtml = dog.photo
      ? '<img src="' + dog.photo + '" alt="' + dog.name + '" loading="lazy">'
      : '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:var(--cream-dim);font-size:0.8rem;">No photo</div>';
    var metaParts = [];
    if (dog.breed) metaParts.push(dog.breed);
    if (dog.age) metaParts.push(dog.age);
    if (dog.gender) metaParts.push(dog.gender);

    var linkUrl, isDirect, orgLabel;
    if (typeof dog.isDirectLink === 'boolean') {
      // Pets mode: Worker already resolved the URL and org name
      linkUrl = dog.url || null;
      isDirect = dog.isDirectLink;
      orgLabel = dog.orgName;
    } else {
      // Rescues mode: raw animal URL, client-side fallback to the org's site
      linkUrl = dog.url || fallbackUrl || null;
      isDirect = Boolean(dog.url);
      orgLabel = fallbackOrgName;
    }

    var linkHtml;
    if (!linkUrl) {
      linkHtml = '<span class="rev-dog-link disabled">Details unavailable</span>';
    } else if (isDirect) {
      linkHtml = '<a href="' + linkUrl + '" target="_blank" rel="noopener" class="rev-dog-link">Meet ' + dog.name.split(' ')[0] + '</a>';
    } else {
      var label = orgLabel
        ? ('Search for ' + dog.name.split(' ')[0] + ' at ' + orgLabel)
        : ('Search for ' + dog.name.split(' ')[0]);
      linkHtml = '<a href="' + linkUrl + '" target="_blank" rel="noopener" class="rev-dog-link">' + label + ' &rarr;</a>';
    }

    return '' +
      '<div class="rev-dog-card">' +
        '<div class="rev-dog-photo">' + photoHtml + '</div>' +
        '<div class="rev-dog-body">' +
          '<h3>' + dog.name + '</h3>' +
          '<div class="rev-dog-meta">' + metaParts.join(' · ') + '</div>' +
          (dog.distance ? '<div class="rev-dog-distance">' + dog.distance + ' miles away</div>' : '<div class="rev-dog-distance">&nbsp;</div>') +
          linkHtml +
        '</div>' +
      '</div>';
  }

  function renderDogGrid(dogs, fallbackUrl, fallbackOrgName, append) {
    var html = dogs.map(function (dog) {
      return dogCardHtml(dog, fallbackUrl, fallbackOrgName);
    }).join('');
    if (append) {
      gridEl.innerHTML += html;
    } else {
      gridEl.innerHTML = html;
    }
  }

  function updateLoadMoreVisibility(hasMore) {
    loadMoreWrap.style.display = hasMore ? 'block' : 'none';
    loadMoreBtn.disabled = false;
    loadMoreBtn.textContent = 'Load More';
  }

  function searchPets(zip, distance, state, breed, page, append) {
    page = page || 1;
    var url = WORKER_URL + '?mode=animals&zip=' + encodeURIComponent(zip) + '&distance=' + encodeURIComponent(distance) + '&page=' + page;
    if (state) url += '&state=' + encodeURIComponent(state);
    if (breed) url += '&breed=' + encodeURIComponent(breed);

    lastPetParams = { zip: zip, distance: distance, state: state, breed: breed };

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Search';
        if (data.error) {
          statusEl.textContent = data.error;
          loadMoreWrap.style.display = 'none';
          return;
        }
        var results = data.results || [];
        if (!append && results.length === 0) {
          statusEl.textContent = 'No dogs found in that area right now — try a wider distance.';
          gridEl.innerHTML = '';
          loadMoreWrap.style.display = 'none';
          return;
        }

        totalShown += results.length;
        currentPage = data.page || page;
        currentPages = data.pages || currentPage;

        var totalCount = typeof data.count === 'number' ? data.count : totalShown;
        statusEl.textContent = totalShown + ' of ' + totalCount + ' dog' + (totalCount !== 1 ? 's' : '') + ' found near you.';
        renderDogGrid(results, null, null, append);
        updateLoadMoreVisibility(Boolean(data.hasMore));
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Search';
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = 'Load More';
        statusEl.textContent = 'Something went wrong. Please try again.';
      });
  }

  function searchRescues(zip, distance, state) {
    var url = WORKER_URL + '?mode=orgs&zip=' + encodeURIComponent(zip) + '&distance=' + encodeURIComponent(distance);
    if (state) url += '&state=' + encodeURIComponent(state);

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Search';
        if (data.error) { statusEl.textContent = data.error; orgWrap.style.display = 'none'; return; }
        var orgs = data.results || [];
        if (orgs.length === 0) {
          statusEl.textContent = 'No rescues found in that area — try a wider distance.';
          orgWrap.style.display = 'none';
          orgSelect.innerHTML = '';
          gridEl.innerHTML = '';
          return;
        }
        orgUrlsById = {};
        orgSelect.innerHTML = orgs.map(function (org) {
          orgUrlsById[org.id] = org.url || null;
          var locBits = [org.city, org.state].filter(Boolean).join(', ');
          var label = org.name + (locBits ? ' — ' + locBits : '') + (org.distance ? ' (' + org.distance + ' mi)' : '');
          return '<option value="' + org.id + '">' + label + '</option>';
        }).join('');
        orgWrap.style.display = 'flex';
        statusEl.textContent = orgs.length + ' rescue' + (orgs.length !== 1 ? 's' : '') + ' found. Showing dogs from the closest one.';
        currentOrgID = orgs[0].id;
        currentOrgUrl = orgs[0].url || null;
        loadOrgAnimals(currentOrgID, 1, false);
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Search';
        statusEl.textContent = 'Something went wrong. Please try again.';
      });
  }

  function loadOrgAnimals(orgID, page, append) {
    page = page || 1;
    var breed = breedInput.value.trim();
    var url = WORKER_URL + '?mode=animalsByOrg&orgID=' + encodeURIComponent(orgID) + '&page=' + page;
    if (breed) url += '&breed=' + encodeURIComponent(breed);

    var selectedOrgLabel = orgSelect.options[orgSelect.selectedIndex]
      ? orgSelect.options[orgSelect.selectedIndex].text
      : '';

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.error) {
          statusEl.textContent = data.error;
          loadMoreWrap.style.display = 'none';
          return;
        }
        var dogs = data.results || [];
        if (!append && dogs.length === 0) {
          statusEl.textContent = breed
            ? 'No ' + breed + ' matches at this rescue right now — try another rescue or clear the breed filter.'
            : 'No dogs listed at this rescue right now.';
          gridEl.innerHTML = '';
          loadMoreWrap.style.display = 'none';
          return;
        }

        totalShown += dogs.length;
        currentPage = data.page || page;
        currentPages = data.pages || currentPage;

        var totalCount = typeof data.count === 'number' ? data.count : totalShown;
        statusEl.textContent = totalShown + ' of ' + totalCount + ' dog' + (totalCount !== 1 ? 's' : '') + ' available' + (selectedOrgLabel ? ' at ' + selectedOrgLabel : '') + '.';
        renderDogGrid(dogs, currentOrgUrl, selectedOrgLabel, append);
        updateLoadMoreVisibility(Boolean(data.hasMore));
      })
      .catch(function () {
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = 'Load More';
        statusEl.textContent = 'Something went wrong loading this rescue. Please try again.';
      });
  }

  orgSelect.addEventListener('change', function () {
    currentOrgID = orgSelect.value;
    currentOrgUrl = orgUrlsById[currentOrgID] || null;
    gridEl.innerHTML = '';
    resetPagination();
    statusEl.textContent = 'Loading dogs...';
    loadOrgAnimals(currentOrgID, 1, false);
  });

  breedInput.addEventListener('input', function () {
    if (currentMode !== 'rescues' || !currentOrgID) return;
    clearTimeout(breedDebounceTimer);
    breedDebounceTimer = setTimeout(function () {
      gridEl.innerHTML = '';
      resetPagination();
      loadOrgAnimals(currentOrgID, 1, false);
    }, 450);
  });

  loadMoreBtn.addEventListener('click', function () {
    loadMoreBtn.disabled = true;
    loadMoreBtn.textContent = 'Loading...';
    var nextPage = currentPage + 1;
    if (currentMode === 'pets' && lastPetParams) {
      searchPets(lastPetParams.zip, lastPetParams.distance, lastPetParams.state, lastPetParams.breed, nextPage, true);
    } else if (currentMode === 'rescues' && currentOrgID) {
      loadOrgAnimals(currentOrgID, nextPage, true);
    }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var zip = document.getElementById('rev-zip').value.trim();
    var distance = document.getElementById('rev-distance').value;
    var state = document.getElementById('rev-state').value;
    var breed = breedInput.value.trim();
    if (!zip) return;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Searching...';
    gridEl.innerHTML = '';
    resetPagination();

    if (currentMode === 'pets') {
      statusEl.textContent = 'Looking for dogs near you...';
      orgWrap.style.display = 'none';
      searchPets(zip, distance, state, breed, 1, false);
    } else {
      statusEl.textContent = 'Looking for rescues near you...';
      searchRescues(zip, distance, state);
    }
  });
})();